import BaseApi from '@/api/controller/base';

const RESOURCE_API_URL = 'resource/';

class ResourceApi extends BaseApi {
  constructor() {
    super(RESOURCE_API_URL);
  }

  async w2(clientId) {
    const response = await this.api.get(`w2/${clientId}`);
    return response.data;
  }

  async w2AdHoc(transferObject) {
    const response = await this.api.post('w2AdHoc', transferObject);
    return response.data;
  }

  async earlyBirdEnrollmentPacket(clientId) {
    const response = await this.api.get(`earlyBirdEnrollmentPacket/${clientId}`);
    return response.data;
  }

  async rafPayoutConfirmation(transactionId) {
    const response = await this.api.get(`rafPayoutConfirmation/${transactionId}`);
    return response.data;
  }

  async rafSlips(clientId) {
    const response = await this.api.get(`rafSlips/${clientId}`);
    return response.data;
  }

  async rafSlipsForBusiness(businessId) {
    const response = await this.api.get(`rafSlips/business/${businessId}`);
    return response.data;
  }
}

const apiInstance = new ResourceApi();
export { ResourceApi, apiInstance };
export default apiInstance;
